// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609152006/js/" + chunkId + "." + {"44":"355b15b0","225":"f67d5e54","481":"e47e1579","486":"6e5d09d9","770":"dd671396"}[chunkId] + ".0.08896011622673627.chunk.js";
};